import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { BASE_URL } from '../constants'
import { IProject } from '../model/interfaces'
import { getTokenFromLocalStorage } from '../../utils'

export const projectsApi = createApi({
  reducerPath: 'projectsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_URL}/project`,
    headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
  }),

  tagTypes: ['Projects', 'AllProjects', 'ProjectEmployeeLinks'],
  endpoints: (builder) => ({
    getProjects: builder.query<IProject[], void>({
      query: () => {
        return {
          method: 'GET',
          url: '',
          headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
        }
      },
      providesTags: ['AllProjects']
    }),
    getMyProjects: builder.query<IProject[], void>({
      query: () => {
        return {
          method: 'GET',
          url: '/my',
          headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
        }
      },
      providesTags: ['Projects']
    }),
    createUserProject: builder.mutation<void, string>({
      query: (projectId: string) => ({
        method: 'POST',
        url: `/my/${projectId}`,
        headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
      }),
      invalidatesTags: ['Projects', 'ProjectEmployeeLinks']
    }),
    deleteUserProject: builder.mutation<void, string>({
      query: (id: string) => ({
        method: 'DELETE',
        url: `/my/${id}`,
        headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
      }),
      invalidatesTags: ['Projects', 'ProjectEmployeeLinks']
    }),
    createProjects: builder.mutation<void, IProject>({
      query: (project: IProject) => ({
        method: 'POST',
        url: '',
        body: project,
        headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
      }),
      invalidatesTags: ['Projects', 'AllProjects']
    }),
    updateProject: builder.mutation<void, IProject>({
      query: (project: IProject) => ({
        method: 'PUT',
        url: `/${project._id}`,
        body: project,
        headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
      }),
      invalidatesTags: ['Projects', 'AllProjects']
    }),
    deleteProject: builder.mutation<void, string>({
      query: (id: string) => ({
        method: 'DELETE',
        url: `/${id}`,
        headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
      }),
      invalidatesTags: ['Projects', 'AllProjects']
    })
  })
})

export const {
  useGetMyProjectsQuery,
  useLazyGetMyProjectsQuery,
  useCreateUserProjectMutation,
  useDeleteUserProjectMutation,
  useGetProjectsQuery,
  useLazyGetProjectsQuery,
  useCreateProjectsMutation,
  useUpdateProjectMutation,
  useDeleteProjectMutation
} = projectsApi
